import React, { useEffect, useState, useContext } from "react";
import { ServiceContext } from "context/ServiceContextProvider";
import { useNavigate } from "react-router-dom";
import { IsValidPermissions } from "../../src/Routes/AuthProtected";

const Navdata = () => {
  const history = useNavigate();
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error(
      "ServiceContext must be used within a ServiceContextProvider",
    );
  }

  const { featureFlags, getEmployeeUUID, getPermissionList } = context;

  //state data
  const [isDashboard, setIsDashboard] = useState<boolean>(false);
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [isProject, setIsProject] = useState<boolean>(false);
  const [isTask, setIsTask] = useState<boolean>(false);
  const [isMembers, setIsMembers] = useState<boolean>(false);
  const [isReport, setIsReport] = useState<boolean>(false);
  const [isWorkFlow, setIsWorkFlow] = useState<boolean>(false);
  const [isRoles, setIsRoles] = useState<boolean>(false);
  const [isInventory, setIsInventory] = useState<boolean>(false);
  const [isSafetyApp, setIsSafetyApp] = useState<boolean>(false);
  const [isReports, setIsReports] = useState<boolean>(false);
  const [isRiskAssessments, setIsRiskAssessments] = useState<boolean>(false);
  const [isSafetyAppWorkFlow, setIsSafetyAppWorkFlow] =
    useState<boolean>(false);
  const [isSafetyAppPermits, setIsSafetyAppPermits] = useState<boolean>(false);

  const [isInventoryWorkFlow, setInventoryWorkFlow] = useState<boolean>(false);
  const [isInventoryItems, setIsInventoryItems] = useState<boolean>(false);
  const [isToolBoxMeeting, setIsToolBoxMeeting] = useState<boolean>(false);
  const [isIncidentReports, setIsIncidentReports] = useState<boolean>(false);

  const [isSafetyAppWorkApproval, setIsSafetyAppWorkApproval] =
    useState<boolean>(false);
  const [isSafetyAppApprovals, setIsSafetyAppApprovals] =
    useState<boolean>(false);
  const [isMobileIOSLink, setIsMobileIOSLink] = useState<boolean>(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState<boolean>(false);
  const [isSignUp, setIsSignUp] = useState<boolean>(false);
  const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState<boolean>(false);
  const [isLockScreen, setIsLockScreen] = useState<boolean>(false);
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState<boolean>(false);
  const [isVerification, setIsVerification] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Project") {
      setIsProject(false);
    }
    if (iscurrentState !== "Task") {
      setIsTask(false);
    }
    if (iscurrentState !== "Members") {
      setIsMembers(false);
    }
    if (iscurrentState !== "Report") {
      setIsReport(false);
    }
    if (iscurrentState !== "WorkFlow") {
      setIsWorkFlow(false);
    }
    if (iscurrentState !== "Roles") {
      setIsRoles(false);
    }
    if (iscurrentState !== "Inventory") {
      setIsInventory(false);
    }
    if (iscurrentState !== "SafetyApp") {
      setIsSafetyApp(false);
    }
    if (iscurrentState !== "Reports") {
      setIsReports(false);
    }
    if (iscurrentState !== "Assessment") {
      setIsRiskAssessments(false);
    }
    if (iscurrentState !== "SafetyAppApprovals") {
      setIsSafetyAppApprovals(false);
    }
    if (iscurrentState !== "ToolBoxMeeting") {
      setIsToolBoxMeeting(false);
    }
    if (iscurrentState !== "IncidentReports") {
      setIsIncidentReports(false);
    }
    if (iscurrentState !== "MobileLink") {
      setIsMobileIOSLink(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isAuth,
    isProject,
    isTask,
    isMembers,
    isReport,
    isWorkFlow,
    isRoles,
    isInventory,
    isSafetyApp,
    isSafetyAppApprovals,
    isMobileIOSLink,
  ]);

  const menuItems: any = [
    {
      label: "Home",
      isHeader: true,
    },
    (IsValidPermissions(["VIEW_ADMIN_DASHBOARD"]) ||
      IsValidPermissions(["VIEW_EMPLOYEE_DASHBOARD"]) ||
      IsValidPermissions(["VIEW_LTA_DASHBOARD"])) && {
      id: "dashboard",
      label: "Dashboards",
      icon: "mdi mdi-speedometer",
      link: "/dashboard",
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      label: "apps",
      isHeader: true,
    },
    featureFlags.Members &&
      IsValidPermissions(["VIEW_ALL_MEMBERS"]) && {
        id: "members",
        label: "Members",
        icon: "ri-team-fill",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsMembers(!isMembers);
          setIscurrentState("Members");
          updateIconSidebar(e);
        },
        stateVariables: isMembers,
        subItems: [
          // {
          //   id: "members_profile",
          //   label: "Members Profile",
          //   link: "/pages-profile",
          //   parentId: "members",
          // },
          // {
          //   id: "members_list",
          //   label: "Members List",
          //   link: "/apps-ecommerce-orders",
          //   parentId: "members",
          // },
          {
            id: "members_customers",
            label: "New Member",
            link: "/members-list-create?create_members=true",
            parentId: "members",
          },
          {
            id: "members_customers",
            label: "List Members",
            link: "/members-list",
            parentId: "members",
          },
        ],
      },
    featureFlags.Members &&
      IsValidPermissions(["VIEW_ONLY_MEMBERS"]) && {
        id: "members",
        label: "Members",
        icon: "ri-team-fill",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsMembers(!isMembers);
          setIscurrentState("Members");
          updateIconSidebar(e);
        },
        stateVariables: isMembers,
        subItems: [
          {
            id: "members_customers",
            label: "Members",
            link: `/profile/${getEmployeeUUID}`,
            parentId: "members",
          },
        ],
      },
    // featureFlags.Workflow &&
    //   (IsValidPermissions(["WORKFLOW_VIEW_ALL"]) ||
    //     IsValidPermissions(["WORKFLOW_APPROVALS_VIEW_ALL"])) && {
    //     id: "WorkFlow",
    //     label: "WorkFlow",
    //     icon: "bx bx-line-chart-down",
    //     link: "/#",
    //     click: function (e: any) {
    //       e.preventDefault();
    //       setIscurrentState("WorkFlow");
    //       setIsWorkFlow(!isWorkFlow);
    //       updateIconSidebar(e);
    //     },
    //     stateVariables: isWorkFlow,
    //     subItems: [
    //       IsValidPermissions(["WORKFLOW_VIEW_ALL"]) && {
    //         id: "workflow_list",
    //         label: "WorkFlowList",
    //         link: "/workflow-list",
    //         parentId: "WorkFlow",
    //       },
    //       IsValidPermissions(["WORKFLOW_APPROVALS_VIEW_ALL"]) && {
    //         id: "work_flow_approvels",
    //         label: "WorkFlow Approvals",
    //         link: "/workflowaccess-list",
    //         parentId: "WorkFlow",
    //       },
    //     ].filter(Boolean),
    //   },
    featureFlags["Access Control"] &&
      (IsValidPermissions(["VIEW_ALL_ROLE_ACCESS"]) ||
        IsValidPermissions(["VIEW_ALL_ROLE_AND_PAGE_ACCESS"])) && {
        id: "Access Control",
        label: "Access Control",
        icon: "bx bxs-wrench",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsRoles(!isRoles);
          setIscurrentState("Roles");
          updateIconSidebar(e);
        },
        stateVariables: isRoles,
        subItems: [
          IsValidPermissions(["VIEW_ALL_ROLE_ACCESS"]) && {
            id: "role_access",
            label: "Role Access",
            link: "/roles-list",
            parentId: "Access Control",
          },
          IsValidPermissions(["VIEW_ALL_ROLE_AND_PAGE_ACCESS"]) && {
            id: "page_access",
            label: "Roles & Page Access",
            link: "/page-access-list",
            parentId: "Access Control",
          },
        ].filter(Boolean),
      },

    featureFlags["Resource Inventory"] &&
      (IsValidPermissions(["VIEW_ALL_CATEGORIES"]) ||
        IsValidPermissions(["VIEW_ALL_MEASUREMENTS"]) ||
        IsValidPermissions(["VIEW_ALL_PRODUCTS"]) ||
        IsValidPermissions(["VIEW_ALL_SUPPLIERS"]) ||
        IsValidPermissions(["VIEW_ALL_INVENTORY_WORKFLOW"]) ||
        IsValidPermissions(["VIEW_ALL_INVENTORY_APPROVALS"]) ||
        IsValidPermissions(["VIEW_ALL_STOCKS"])) && {
        id: "Inventory",
        label: "Resource Inventory",
        icon: "bx bxs-store",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsInventory(!isInventory);
          setIscurrentState("Inventory");
          updateIconSidebar(e);
        },
        stateVariables: isInventory,
        subItems: [
          (IsValidPermissions(["VIEW_ALL_INVENTORY_WORKFLOW"]) ||
            IsValidPermissions(["VIEW_ALL_INVENTORY_APPROVALS"])) && {
            id: "inventoryworkflow",
            label: "WorkFlow",
            link: "/#",
            isChildItem: true,
            click: function (e: any) {
              e.preventDefault();
              setInventoryWorkFlow(!isInventoryWorkFlow);
            },
            stateVariables: isInventoryWorkFlow,
            childItems: [
              IsValidPermissions(["VIEW_ALL_INVENTORY_WORKFLOW"]) && {
                id: 1,
                label: "Work Flow",
                link: "/inventory-workflow-list",
                parentId: "Inventory",
              },
              IsValidPermissions(["VIEW_ALL_INVENTORY_APPROVALS"]) && {
                id: 7,
                label: "WorkFlow Approvals",
                link: "/inventory-workflowaccess-list",
                parentId: "WorkFlow",
              },
            ],
          },
          {
            id: "inventory",
            label: "Inventory",
            link: "/#",
            isChildItem: true,
            click: function (e: any) {
              e.preventDefault();
              setIsInventoryItems(!isInventoryItems);
            },
            stateVariables: isInventoryItems,
            childItems: [
              IsValidPermissions(["VIEW_ALL_MEASUREMENTS"]) && {
                id: 2,
                label: "Measurements",
                link: "/measurment-list",
                parentId: "Inventory",
              },
              IsValidPermissions(["VIEW_ALL_SUPPLIERS"]) && {
                id: 3,
                label: "Suppliers",
                link: "/supplier-list",
                parentId: "Inventory",
              },
              IsValidPermissions(["VIEW_ALL_CATEGORIES"]) && {
                id: 4,
                label: "Categories",
                link: "/category-list",
                parentId: "Inventory",
              },
              IsValidPermissions(["VIEW_ALL_PRODUCTS"]) && {
                id: 5,
                label: "Products",
                link: "/product-list",
                parentId: "Inventory",
              },
              IsValidPermissions(["VIEW_ALL_STOCKS"]) && {
                id: 6,
                label: "Stocks",
                link: "/stock-list",
                parentId: "Inventory",
              },
            ],
          },
        ],
        // subItems: [

        // ].filter(Boolean),
      },

    featureFlags["Approvals"] &&
      (IsValidPermissions(["VIEW_ALL_SAFETY_APP_APPROVALS"]) ||
        IsValidPermissions(["VIEW_ONLY_SAFETY_APP_APPROVALS"])) && {
        id: "SafetyAppApprovals",
        label: "Approval",
        icon: "bx bxs-file",
        link: "/safety-app-workflow-approvel-list",
        click: function (e: any) {
          e.preventDefault();
          setIsSafetyAppApprovals(!isSafetyAppApprovals);
          setIscurrentState("SafetyAppApprovals");
          updateIconSidebar(e);
        },
      },
    //Workflow Nav link

    IsValidPermissions(["VIEW_ALL_SAFETY_APP_WORKFLOW"]) && {
      id: "WorkFlow",
      label: "Work Flow",
      icon: "bx bxs-file",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsWorkFlow(!isWorkFlow);
        setIscurrentState("WorkFlow");
        updateIconSidebar(e);
      },
      stateVariables: isWorkFlow,
      subItems: [
        {
          id: 3,
          label: "New Work Flow",
          link: "/safety-app-workflow-list-create?create_workflow=true",
          parentId: "WorkFlow",
        },
        {
          id: 2,
          label: "List Work Flow",
          link: "/safety-app-workflow-list?create_workflow=null",
          parentId: "WorkFlow",
        },
      ],
    },
    featureFlags["Safety App"] &&
      (IsValidPermissions(["VIEW_ALL_HOT_WORK_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_HOT_WORK_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_GENERAL_WORK_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_GENERAL_WORK_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_WORK_AT_HEIGHT_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_WORK_AT_HEIGHT_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_EXCAVATION_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_EXCAVATION_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_LIFTING_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_LIFTING_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_CONFINED_SPACE_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_CONFINED_SPACE_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_PIPE_JACKING_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_PIPE_JACKING_PERMIT"]) ||
        IsValidPermissions(["VIEW_ONLY_PILING_PERMIT"]) ||
        IsValidPermissions(["VIEW_ALL_PILING_PERMIT"])) && {
        id: "SafetyApp",
        label: "Safety App",
        icon: "ri-shield-user-fill",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsSafetyApp(!isSafetyApp);
          setIscurrentState("SafetyApp");
          updateIconSidebar(e);
        },
        stateVariables: isSafetyApp,
        subItems: [
          (IsValidPermissions(["VIEW_ALL_HOT_WORK_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_HOT_WORK_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_GENERAL_WORK_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_GENERAL_WORK_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_WORK_AT_HEIGHT_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_WORK_AT_HEIGHT_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_EXCAVATION_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_EXCAVATION_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_LIFTING_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_LIFTING_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_CONFINED_SPACE_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_CONFINED_SPACE_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_PIPE_JACKING_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_PIPE_JACKING_PERMIT"]) ||
            IsValidPermissions(["VIEW_ONLY_PILING_PERMIT"]) ||
            IsValidPermissions(["VIEW_ALL_PILING_PERMIT"])) && {
            id: "permits",
            label: "Permits",
            link: "/#",
            isChildItem: true,
            click: function (e: any) {
              e.preventDefault();
              setIsSafetyAppPermits(!isSafetyAppPermits);
            },
            stateVariables: isSafetyAppPermits,
            childItems: [
              (IsValidPermissions(["VIEW_ALL_HOT_WORK_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_HOT_WORK_PERMIT"])) && {
                id: 2,
                label: "Hot Work Permit",
                link: "/hotworkpermit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_GENERAL_WORK_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_GENERAL_WORK_PERMIT"])) && {
                id: 3,
                label: "General Work Permit",
                link: "/generalworkpermit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_WORK_AT_HEIGHT_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_WORK_AT_HEIGHT_PERMIT"])) && {
                id: 4,
                label: "Work At Height Permit",
                link: "/workatheightpermit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_EXCAVATION_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_EXCAVATION_PERMIT"])) && {
                id: 5,
                label: "Excavation Permit",
                link: "/excavationpermit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_LIFTING_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_LIFTING_PERMIT"])) && {
                id: 6,
                label: "Lifting Permit",
                link: "/lifting-permit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_CONFINED_SPACE_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_CONFINED_SPACE_PERMIT"])) && {
                id: 7,
                label: "Confined Space Permit",
                link: "/confinedspace-permit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_PIPE_JACKING_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_PIPE_JACKING_PERMIT"])) && {
                id: 8,
                label: "Pipe Jacking Permit",
                link: "/pipe-jacking-permit-list",
                parentId: "SafetyApp",
              },
              (IsValidPermissions(["VIEW_ALL_PILING_PERMIT"]) ||
                IsValidPermissions(["VIEW_ONLY_PILING_PERMIT"])) && {
                id: 9,
                label: "Piling Work Permit",
                link: "/piling-permit-list",
                parentId: "SafetyApp",
              },
            ],
          },
          (IsValidPermissions(["VIEW_ALL_TOOLBOX_MEETING"]) ||
            IsValidPermissions(["VIEW_ONLY_TOOLBOX_MEETING"])) && {
            id: "ToolBoxMeeting",
            label: "ToolBox Meeting",
            link: "/#",
            isChildItem: true,
            click: function (e: any) {
              e.preventDefault();
              setIsToolBoxMeeting(!isToolBoxMeeting);
            },
            stateVariables: isToolBoxMeeting,
            childItems: [
              (IsValidPermissions(["VIEW_ALL_TOOLBOX_MEETING"]) ||
                IsValidPermissions(["VIEW_ONLY_TOOLBOX_MEETING"])) && {
                id: 10,
                label: "ToolBox Meeting",
                link: "/toolboxmeeting-list",
                parentId: "ToolBoxMeeting",
              },
            ],
          },
        ],
      },

    // Reports

    featureFlags["Safety App"] &&
      (IsValidPermissions(["VIEW_ONLY_ACCIDENT_REPORT"]) ||
        IsValidPermissions(["VIEW_ALL_ACCIDENT_REPORT"]) ||
        IsValidPermissions(["VIEW_ONLY_NEAR_MISS_INCIDENT"]) ||
        IsValidPermissions(["VIEW_ALL_NEAR_MISS_INCIDENT"]) ||
        IsValidPermissions(["VIEW_ONLY_INSPECTION_REPORT"]) ||
        IsValidPermissions(["VIEW_ALL_INSPECTION_REPORT"]) ||
        IsValidPermissions(["VIEW_ONLY_RISK_ASSESSMENT"]) ||
        IsValidPermissions(["VIEW_ALL_RISK_ASSESSMENT"])) && {
        id: "Reports",
        label: "Reports",
        icon: "mdi mdi-file",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsReports(!isReports);
          setIscurrentState("Reports");
          updateIconSidebar(e);
        },
        stateVariables: isReports,

        subItems: [
          (IsValidPermissions(["VIEW_ONLY_INSPECTION_REPORT"]) ||
            IsValidPermissions(["VIEW_ALL_INSPECTION_REPORT"])) && {
            id: "inspection_list",
            label: "Inspection Report",
            link: "/report-list",
            parentId: "Report",
          },
          (IsValidPermissions(["VIEW_ALL_RISK_ASSESSMENT"]) ||
            IsValidPermissions(["VIEW_ONLY_RISK_ASSESSMENT"])) && {
            id: "assessment_list",
            label: "Risk Assessments",
            link: "/risk-assessment-list",
            parentId: "Report",
          },

          (IsValidPermissions(["VIEW_ONLY_ACCIDENT_REPORT"]) ||
            IsValidPermissions(["VIEW_ALL_ACCIDENT_REPORT"]) ||
            IsValidPermissions(["VIEW_ONLY_NEAR_MISS_INCIDENT"]) ||
            IsValidPermissions(["VIEW_ALL_NEAR_MISS_INCIDENT"])) && {
            id: "IncidentReports",
            label: "Incident Reports",
            link: "/#",
            isChildItem: true,
            click: function (e: any) {
              e.preventDefault();
              setIsIncidentReports(!isIncidentReports);
            },
            stateVariables: isIncidentReports,
            childItems: [
              (IsValidPermissions(["VIEW_ALL_ACCIDENT_REPORT"]) ||
                IsValidPermissions(["VIEW_ONLY_ACCIDENT_REPORT"])) && {
                id: 11,
                label: "Accident Report",
                link: "/accident-report-list",
                parentId: "IncidentReports",
              },
              (IsValidPermissions(["VIEW_ALL_NEAR_MISS_INCIDENT"]) ||
                IsValidPermissions(["VIEW_ONLY_NEAR_MISS_INCIDENT"])) && {
                id: 12,
                label: "Near Miss Report",
                link: "/nearmiss-report-list",
                parentId: "IncidentReports",
              },
            ],
          },
        ],
      },
    featureFlags.Project &&
      (IsValidPermissions(["VIEW_ALL_PROJECT"]) ||
        IsValidPermissions(["VIEW_ONLY_PROJECT"])) && {
        id: "project",
        label: "Project",
        icon: "bx bxs-folder-open",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsProject(!isProject);
          setIscurrentState("Project");
          updateIconSidebar(e);
        },
        stateVariables: isProject,
        subItems: [
          IsValidPermissions(["ADD_PROJECT"]) && {
            id: "project_add",
            label: "New Project",
            link: "/apps-projects-list-create?create_project=true",
            parentId: "project",
          },
          (IsValidPermissions(["VIEW_ALL_PROJECT"]) ||
            IsValidPermissions(["VIEW_ONLY_PROJECT"])) && {
            id: "project_list",
            label: "List Project",
            link: "/apps-projects-list",
            parentId: "project",
          },
          // {
          //   id: "project_overview",
          //   label: "Overview",
          //   link: "/apps-projects-overview",
          //   parentId: "project",
          // },
          // {
          //   id: "project_create",
          //   label: "Create Project",
          //   link: "/apps-projects-create",
          //   parentId: "project",
          // },
        ].filter(Boolean),
      },

    // {
    //   id: "MobileLink",
    //   label: "Mobile Access",
    //   icon: "bx bxs-mobile",
    //   link: "/#",
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setIsMobileIOSLink(!isMobileIOSLink)
    //     setIscurrentState("MobileLink");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isMobileIOSLink,
    //   subItems: [
    //     {
    //       id: "moblile_Access",
    //       label: "Mobile Access",
    //       link: "/page-access-list",
    //       parentId: "MobileLink ",
    //     },
    //   ].filter(Boolean),
    // },

    (IsValidPermissions(["VIEW_ADMIN_DASHBOARD"]) ||
      IsValidPermissions(["VIEW_EMPLOYEE_DASHBOARD"])) && {
      id: "MobileLink",
      label: "Mobile App",
      icon: "bx bxs-mobile",
      link: "/mobile-app",
      click: function (e: any) {
        e.preventDefault();
        setIsMobileIOSLink(!isMobileIOSLink);
        setIscurrentState("MobileLink");
        updateIconSidebar(e);
      },
    },

    featureFlags.Task &&
      (IsValidPermissions(["VIEW_ALL_TASK"]) ||
        IsValidPermissions(["VIEW_ONLY_TASK"])) && {
        id: "task",
        label: "Task",
        icon: "bx bxs-server",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsTask(!isTask);
          setIscurrentState("Task");
          updateIconSidebar(e);
        },
        stateVariables: isTask,
        subItems: [
          // {
          //     id: "kanban_board",
          //     label: "Kanban Board",
          //     link: "/apps-tasks-kanban",
          //     parentId: "task",
          // },
          IsValidPermissions(["ADD_TASK"]) && {
            id: "task_list_create",
            label: "Create New Task",
            link: "/apps-tasks-list-view-create?create_task=true",
            parentId: "task",
          },
          IsValidPermissions(["VIEW_ALL_TASK"]) && {
            id: "task_list",
            label: "Task List",
            link: "/apps-tasks-list-view",
            parentId: "task",
          },
          // {
          //     id: "task_detail",
          //     label: "Task Details",
          //     link: "/apps-tasks-details",
          //     parentId: "task",
          // },
          // {
          //   id: "resource_dashboard",
          //   label: "Resource Dashboard",
          //   link: "/advance-ui-ratings",
          //   parentId: "task",
          // },
        ].filter(Boolean),
      },
  ].filter(Boolean);
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
